import appManager from '../../app/appManager';
import AppModule from '../../app/lib/AppModule';
import { SoftPhoneCallControl, SoftPhoneDialer } from './types';
import { EventBus } from '@servicetitan/web-components';
import WebPhoneService from './WebPhoneService';
import { callState } from './state';
import ToastModule from '@modules/ToastModule';

// THIS MODULE IS A WORK IN-PROGRESS A WILL BE REFACTORED
// SEE DAVEW/KENNY BEFORE MAKING MAJOR CHANGES

export class SoftPhoneModule extends AppModule {
  private _allowUI = false;
  private _initialized = false;
  override events = [
    'phone.call.answered',
    'phone.call.ended',
    'phone.call.missed',
    'phone.call.placed',
    'phone.prepare.outbound',
  ];

  override preload(): void {
    // keep track of signed in status so we
    // don't show UI when not signed in
    this.app.events.on('auth.signin', () => {
      this._allowUI = true;
    });
    this.app.events.on('auth.signout', () => {
      this._allowUI = false;
    });
  }

  public get enabled(): boolean {
    // TODO: check if MFE softphone enabled
    return false;
  }

  public get dialer(): SoftPhoneDialer {
    this.isPhoneInitialized({ showToast: true });
    return {
      dial: (number: string | number) =>
        WebPhoneService.dial(number.toString()),
      clear: () => WebPhoneService.clear(),
      backspace: () => WebPhoneService.backspace(),
      autoAction: () => WebPhoneService.autoAction(),
    };
  }

  public get callControl(): SoftPhoneCallControl {
    this.isPhoneInitialized({ showToast: true });
    return {
      answer: () => WebPhoneService.answer(),
      cancel: () => WebPhoneService.cancel(),
      hangup: () => WebPhoneService.hangup(),
      hold: () => WebPhoneService.hold(),
      unhold: () => WebPhoneService.unhold(),
      mute: () => WebPhoneService.mute(),
      unmute: () => WebPhoneService.unmute(),
      disconnect: () => WebPhoneService.disconnect(),
    };
  }

  public isAttemptingCall(): boolean {
    return callState.hasSession;
  }

  public isInCall(): boolean {
    return callState.established && callState.hasSession;
  }

  public endCall(callId: string): void {
    if (this.isAttemptingCall() && callState.callId === callId) {
      WebPhoneService.hangup();
    }
  }

  public initializeWebPhoneService(webPhoneEventBus?: EventBus) {
    if (!webPhoneEventBus) {
      throw new Error('Event bus is required to initialize the softphone');
    }
    if (this._initialized) {
      return;
    }
    WebPhoneService.initialize(webPhoneEventBus, this.app.logger);
    this._initialized = true;
  }

  public callNumber(number: string, recipientName?: string, tenantId?: string) {
    if (this.isPhoneInitialized({ showToast: true })) {
      this.app.events.emit(`phone.prepare.outbound`, {
        outgoingNumber: number,
        displayName: recipientName,
        tenantId,
      });
      WebPhoneService.callNumber(number);
    }
  }

  private isPhoneInitialized(options?: { showToast?: boolean }): boolean {
    if (this._allowUI && !this._initialized && options?.showToast) {
      ToastModule.showToast({
        title: 'Softphone not initialized',
        status: 'critical',
      });
    }
    return this._initialized;
  }
}

export default new SoftPhoneModule(
  appManager.events,
  appManager.logger('SoftPhone'),
);
